import jquery from 'jquery'
import Jspdf from 'jspdf'

export default {
  dat2str: function(dat) {
  if (dat == "0000-00-00" || dat == "" || dat == null)
  {
     return "__/__/____"
  } else {
     var res = dat.split("-")
     return res[2] + "/" + res [1] + "/" + res[0]
  }

},// dd/mm/yyyy -> yyyy-mm-dd
  dat2strReverse: function  (dat)
  {
    if (dat == "00/00/0000" || dat == "" || dat == null || dat == "__/__/____")
    {
       return "0000-00-00"
    } else {
       var res = dat.split("/")
       return res[2] + "-" + res [1] + "-" + res[0]
    }
  },
  str2dat: function  (dat)
  {
    var d = new Date(dat)
    return d
  },
  str2datOrNull: function  (dat)
  {
    if(dat == "" || dat == "0000-00-00")
    {
      return null
    }
    var d = new Date(dat)

    return d
  },
  date2str: function(d) {
    if (d == "00/00/0000" || d == "" || d == null || d == "__/__/____" || d == "0000-00-00") {
      return "0000-00-00"
    }
    var dag = d.getDate()
    var maand = d.getMonth() + 1
    var jaar = d.getFullYear()
    var dagstr = ("0" + dag).slice(-2);
    var maandstr = ("0" + maand).slice(-2)
    var jaarstr = ("0000" + jaar).slice(-4)
    return jaarstr + "-" + maandstr + "-" + dagstr
  },

  date2strf: function (d) {
    if (d == "00/00/0000" || d == "" || d == null || d == "__/__/____") {
      return "__/__/____"
    }
    var dag = d.getDate()
    var maand = d.getMonth() + 1
    var jaar = d.getFullYear()
    var dagstr = ("0" + dag).slice(-2)
    var maandstr = ("0" + maand).slice(-2)
    var jaarstr = ("0000" + jaar).slice(-4)
    return dagstr + "/" + maandstr + "/" + jaarstr
  },

  datetime2strf: function(d) {
    if (d == "00/00/0000" || d == "" || d == null || d == "__/__/____") {
      return "__/__/____"
    }
    var dag = d.getDate()
    var maand = d.getMonth() + 1
    var jaar = d.getFullYear()
    var dagstr = ("0" + dag).slice(-2)
    var maandstr = ("0" + maand).slice(-2)
    var jaarstr = ("0000" + jaar).slice(-4)
    var uren = ("0" + d.getHours()).slice(-2)
    var minuten = ("0" + d.getMinutes()).slice(-2)
    return dagstr + "/" + maandstr + "/" + jaarstr + " - " + uren + ":" + minuten
  },

  vandaag2str: function () {
    var t = new Date()
    return (this.date2str(t))
  },
  vandaag: function () {
    var t = new Date()
    return t
  },
  vandaag2strf: function () {
    var t = new Date()
    return (this.date2strf(t))
  },
  dateDiffInDays: function(a, b) {
    var _MS_PER_DAY = 1000 * 60 * 60 * 24
    // Discard the time and time-zone information.
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate())
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate())

    return Math.floor((utc1 - utc2) / _MS_PER_DAY)
  },
  dat2datornull: function(d) {
    if(d === '0000-00-00') {
      return null
    }
    return d
  },
  datornull2dat: function(d) {
    if(d === null || d === undefined) {
      return '0000-00-00'
    }
    return d
  },
  getVLBLogo: function ()
  {
      var d = 'data:image/jpeg;base64,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'
      return(d)
  },
  calcDatLocStr: function(d) {
    if(d != '0000-00-00') {
      return '(vanaf ' + this.dat2str(d) + ')'
    }
    return ''
  },
  afdrukkenSteekkaart: function(lijst) {
    var doc = new Jspdf('p', 'pt', 'a4')
    var fontname = 'times'
    var i
    for (i in lijst)
    {
      var mach = lijst[i]
      if (i > 0) {
        doc.addPage()
      }
      doc.setFontSize(12)

      doc.setFont(fontname,'bold')
      doc.text(mach.omschrijving,95, 60 )
      doc.addImage(this.getVLBLogo(), 'JPEG', 40, 40, 48, 30)
      var currentdate = new Date()

      var datetime = "Steekkaart op: " + this.datetime2strf(currentdate)
      doc.setFontSize(8)
      doc.text(datetime,550, 60 ,'right')

      var mL = 120 // marge links
      var mL0 = 40 // marge links
      var mL2 = 180 // marge links
      var mL3 = 200 // marge links
      var mLR = 450 // marge van links voor vorstvrij, defect, ...
      var mC = 290 // center??
      var mT = 100 // marge tot boven
      var dy = 0 // huidige verticale shift
      var tss = 15 // tussenafstand tussen twee regels
      var spacer = 20
      var lijnshift = 96

      doc.setFont(fontname,'bold')
      doc.text("Nummer:", mL, mT + dy, 'right');
      doc.setFont(fontname,'normal')
      doc.text(mach.soortID + "." + mach.volgnr, mL + spacer, mT + dy);
      doc.setFont(fontname,'bold')
      doc.text("Vorstvrij:", mLR, mT + dy, 'right');
      doc.setFont(fontname,'normal')
      doc.text(mach.vorstvrij == true ? 'ja' : 'nee', mLR + spacer, mT + dy);
      dy = dy + tss;
      doc.setFont(fontname,'bold')
      doc.text("Soort:",  mL, mT + dy, 'right');
      doc.setFont(fontname,'normal')
      doc.text(mach.soortdesc, mL + spacer, mT + dy);
      doc.setFont(fontname,'bold')
      doc.text("Defect:", mLR, mT + dy, 'right');
      doc.setFont(fontname,'normal')
      doc.text(mach.defect == true ? 'ja' : 'nee', mLR + spacer, mT + dy);
      dy = dy + tss;
      // lijn
      doc.setLineWidth(0.5);
      doc.line(40, dy + lijnshift, 560, dy + lijnshift);
      dy = dy + tss;
      // locaties
      doc.setFont(fontname,'bold')
      doc.text("Huidige locatie:", mL, mT + dy, 'right');
      doc.setFont(fontname,'normal')

      doc.text(mach.selectedWerfText + mach.datlocstr, mL + spacer, mT + dy) + ")";
      dy = dy + tss;
      doc.text("voorgaande locatie 1:", mL, mT + dy, 'right');
      doc.text(mach.selectedWerf2Text + mach.datloc2str, mL + spacer, mT + dy) + ")";
      dy = dy + tss;
      doc.text("voorgaande locatie 2:", mL, mT + dy, 'right');
      doc.text(mach.selectedWerf3Text + mach.datloc3str, mL + spacer, mT + dy) + ")";
      dy = dy + tss;
      // lijn
      doc.setLineWidth(0.5);
      doc.line(40, dy + lijnshift, 560, dy + lijnshift);
      dy = dy + tss;

      if(mach.ureningave == true)
      {
          // urenstand
          doc.setFont(fontname,'bold')
          doc.text("Urenstand:", mL, mT + dy, 'right');
          doc.setFont(fontname,'normal')
          doc.text(Math.round(mach.huidigeurenstand).toString() + " u", mL2 , mT + dy,'right');
          doc.text("opgenomen op: " + this.date2strf(mach.datumurenopgenomenop), mL3 , mT + dy);
          dy = dy + tss;
          doc.setFont(fontname,'bold')
          doc.text("Vorig onderhoud:", mL, mT + dy, 'right');
          doc.setFont(fontname,'normal')
          doc.text(Math.round(mach.vorigeurenstand).toString() + " u", mL2 , mT + dy,'right');
          dy = dy + tss;
          doc.setFont(fontname,'bold')
          doc.text("Interval onderhoud:", mL, mT + dy, 'right');
          doc.setFont(fontname,'normal')
          doc.text(Math.round(mach.omde).toString() + " u", mL2 , mT + dy,'right');
          dy = dy + tss;
          doc.setFont(fontname,'bold')
          doc.text("nog", mL, mT + dy, 'right');
          doc.setFont(fontname,'normal')
          doc.text(  Math.round(mach.omde - (mach.huidigeurenstand - mach.vorigeurenstand)).toString() + " u", mL2 , mT + dy,'right' );
          doc.text(" voor volgend onderhoud", mL2, mT + dy);
          dy = dy + tss;
      }
      else
      {
      }

      doc.setLineWidth(0.5);
      doc.line(40, dy + lijnshift, 560, dy + lijnshift);
      dy = dy + tss;
      doc.setFont(fontname,'bold')
      doc.text("Onderhoudsgeschiedenis", mC, mT + dy, 'center');
      dy = dy + tss;
      doc.setFont(fontname,'normal')

      if(mach.onderhoudtekst != null) {
        doc.text(mach.onderhoudtekst, mL0, mT + dy);
        var dim = doc.getTextDimensions(mach.onderhoudtekst);
        dy = dy + tss + dim.h + 150;
      }

      doc.setFont(fontname,'bold')
      doc.text("Keuringsgeschiedenis", mC, mT + dy, 'center');
      dy = dy + tss;
      doc.setFont(fontname,'normal')

      if(mach.keuringtekst != null) {
        doc.text(mach.keuringtekst, mL0, mT + dy);
        var dim = doc.getTextDimensions(mach.keuringtekst);
        dy = dy + tss + dim.h;
      }
    }


    doc.save('steekkaart.pdf')

  }
}



// WEBPACK FOOTER //
// ./src/functions.js